import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { FormControl, InputLabel, Select, MenuItem, Tooltip, Zoom } from '@material-ui/core';
import { Button, Container, Typography, Link, List, ListItem, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Modal } from '@material-ui/core';
import { connect, ConnectedProps } from 'react-redux';
import store from './../redux/store';
//import { usuario } from '../redux/usuarios/actions';
import { fetchEmpresas } from '../redux/empresas/actions';
import { useNavigate } from 'react-router-dom';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import { InputAdornment } from '@material-ui/core';
import { Email, Phone, Business, ViewHeadline } from '@material-ui/icons';
import { getEmpresas } from '../api';
import { green } from '@material-ui/core/colors';
import moment from 'moment'
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CardMedia from '@mui/material/CardMedia';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import {
    useGridApiRef,
    GridRowsProp,
    GridRowModesModel,
    GridRowModes,
    DataGrid,
    GridColDef,
    GridToolbar,
    GridToolbarContainer,
    GridActionsCellItem,
    GridEventListener,
    GridRowId,
    GridRowModel,
    GridRowEditStopReasons,
    GridValueGetterParams,
    GridToolbarExport,
} from '@mui/x-data-grid';
import { Autocomplete, Avatar, CardActions, CardHeader, Collapse, Divider, LinearProgress, ListItemButton, ListSubheader, Stack, styled, useMediaQuery, CircularProgress } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// Core viewer
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

import dayjs, { Dayjs } from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { DefaultizedPieValueType } from '@mui/x-charts';
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';

import Notifications from './../components/notifications/Notifications';
import ImageCarousel from './../components/carrossel/Imagelist';

import { client, AUTH_USER, CREATE_CREDIT, getUsers, filterRecommendation, filterCredit, filterCompany, whoami, UPDATE_USER, REMOVE_COMPANY, CREATE_COMPANY, getCompanies, UPDATE_COMPANY, getCategories, findProfileByUser, UPDATE_CREDIT, UPDATE_RECOMMENDATION, filterTransaction, verificarStatusCliente, UPDATE_TRANSACTION, filterChatgpt } from '../graphqlClient/graphql'
import { useMutation } from '@apollo/client';
import { serverConfig } from '../api/apiConfig';

const workerUrl = new URL(
  'https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js',
  import.meta.url,
).toString();

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        height: '100%',
        textAlign: 'center',
        width: '100%',
        maxWidth: `1200px`,
    },
    container: {
        display: 'flex',
        justifyContent: 'center',
        //alignItems: 'center',
        height: '100%',
    },
    content: {
        textAlign: 'center',
    },
    title: {
        marginBottom: theme.spacing(2),
    },
    listContainer: {
        //maxWidth:'80%',
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignContent: 'flex-start',
        justifyContent: 'center',
        alignItems: 'flex-start',

        maxHeight: 'calc(100vh - 100px)',
        overflow: 'auto',
        '&::-webkit-scrollbar': {
            width: '8px',
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: '#f1f1f1',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'green',
        },
        '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: 'darkgreen',
        },
    },
    listItem: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: theme.spacing(1),
    },
    deleteButton: {
        marginLeft: theme.spacing(1),
    },
    addButton: {
        margin: theme.spacing(2),
        backgroundColor: green[500],
        color: 'white',
        '&:hover': {
            backgroundColor: green[700],
        },
    },
    
}));

interface ExpandMoreProps extends IconButtonProps {
    expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));

type PropsFromRedux = ConnectedProps<typeof connector>;

const ScoutPage: React.FC<PropsFromRedux> = ({ user, isLoadingUsuarios, isLoadingUsuariosByFilter, isLoadingCreateUsuario, empresas }) => {
    const classes = useStyles();
    const defaultLayoutPluginInstance = defaultLayoutPlugin();
    function getWindowDimensions() {
        const { innerWidth: width, innerHeight: height } = window;
        return { width, height };
    }
    const screenWidth: any = getWindowDimensions().width;
    const navigate = useNavigate();
    const [deleteConfirmationOpen, setDeleteConfirmationOpen] = React.useState(false);
    const [selectedUsuario, setSelectedUsuario] = React.useState('');
    const [addUsuarioModalOpen, setAddUsuarioModalOpen] = React.useState(false);
    const [newUsuarioName, setNewUsuarioName] = React.useState('');
    const [newUsuarioPassword, setNewUsuarioPassword] = React.useState('');
    const [newUsuarioConfirmPassword, setNewUsuarioConfirmPassword] = React.useState('');
    const [newUsuarioEmail, setNewUsuarioEmail] = React.useState('');
    const [newUsuarioTelefone, setNewUsuarioTelefone] = React.useState('');
    const [newUsuarioEmpresa, setNewUsuarioEmpresa] = React.useState('');
    const [editUsuarioData, setEditUsuarioData] = React.useState<any>({});
    const [usuarios, setUsuarios] = React.useState<any>([]);
    const [newUsuarioPermissoes, setNewUsuarioPermissoes] = React.useState<any>({});
    const [editUsuarioModalOpen, setEditUsuarioModalOpen] = React.useState(false);
    const [passwordOpen, setPasswordOpen] = React.useState(false);
    const [loading, setLoading] = React.useState(false);

    const permissoesList = ['administrador', 'gerente', 'basico']

    const [rows, setRows] = React.useState(usuarios);
    const [categories, setCategories] = React.useState<any>([]);
    const [companies, setCompanies] = React.useState<any>([]);
    const [selectedCategory, setSelectedCategory] = React.useState<any>({});
    const [selectedCompany, setSelectedCompany] = React.useState<any>({});
    const [rowModesModel, setRowModesModel] = React.useState<GridRowModesModel>({});
    const [save, setSave] = React.useState(false);
    const [selectedUser, setSelectedUser] = React.useState<any>({ key: 0, value: 'Filtro por operador' });

    const [startDate, setStartDate] = React.useState<any>(null);
    const [endDate, setEndDate] = React.useState<any>(null);
    const [expanded, setExpanded] = React.useState('');
    const [link, setLink] = React.useState('');
    const [referralsRemaining, setReferralsRemaining] = React.useState(0);
    const [referralsRequested, setReferralsRequested] = React.useState(0);
    const [recommendations, setRecommendations] = React.useState<any>([]);
    const [imagesList, setImagesList] = React.useState<any>([]);
    const [referralData, setReferralData] = React.useState<any>({});

    const [referrals, setReferrals] = React.useState<any>([]);
    const [selectedScout, setSelectedScout] = React.useState<any>({});
    const [scoutInfo, setScoutInfo] = React.useState<any>(false);
    const [selectedRecommendation, setSelectedRecommendation] = React.useState<any>({});
    const [credit, setCredit] = React.useState<any>({});
    const [requestPanel, setRequestPanel] = React.useState<any>(false);
    const [requestProposalPanel, setRequestProposalPanel] = React.useState<any>(false);
    const [openPdf, setOpenPdf] = React.useState<any>(false);
    const [openReferral, setOpenReferral] = React.useState<any>(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [defaultPdf, setDefaultPdf] = React.useState<any>('');
    const [favoriteFeedback, setFavoriteFeedback] = React.useState<any>(null);
    const [finalResult, setFinalResult] = React.useState<any>('');
    const [CreateCreditMutation, { data }] = useMutation(CREATE_CREDIT);
    const [UpdateCreditMutation, { data:updateCreditInput }] = useMutation(UPDATE_CREDIT);
    const [UpdateTransactionMutation] = useMutation(UPDATE_TRANSACTION);
    const [UpdateRecommendationMutation, { data: updateRecommendationInput }] = useMutation(UPDATE_RECOMMENDATION);
    const handleAddCredit = async (currentUserPlan?: string) => {
        const planType = currentUserPlan || user?.currentPlan || 'free';
        let planDetails = { amount: 3, amountPdf: 3, amountInterview: 1, amountVisa: 3 }; // free
        
        if (planType === 'plus') {
            planDetails = { amount: 30, amountPdf: 10, amountInterview: 5, amountVisa: 10 };
        } else if (planType === 'basic') {
            planDetails = { amount: 10, amountPdf: 5, amountInterview: 3, amountVisa: 5 };
        }

        const dataToSend = {
            ...planDetails,
            user: user._id,
            active: true,
            type: planType,
            status: 'active',
            expiration: new Date(new Date().setMonth(new Date().getMonth() + 1)).toISOString(),
        }
        console.log('dataToSend', dataToSend)

        try {

            const createCreditInput = dataToSend
            console.log('createCreditInput', dataToSend)

            const result = await CreateCreditMutation({
                variables: {
                    createCreditInput
                },
                onCompleted: ({ createCredit }) => {

                    console.log('credit created== > ', createCredit);
                    setCredit(createCredit);
                    setReferralsRequested(0);
                    setReferralsRemaining(planDetails.amount);
                    const notData = {
                        type: 'success',
                        message: `Credit Created Successfully!`,
                        title: 'wescout',
                        timeOut: 2500,
                        callback: () => { },
                        priority: true,
                    }

                    Notifications(notData)
                }
            });
        } catch (error: any) {
            const notData = {
                type: 'error',
                message: error.message,
                title: 'wescout',
                timeOut: 2500,
                callback: () => { },
                priority: true,
            }
            Notifications(notData)
            console.log("Error at create credit", error)

        }

    };

    const handleExpandClick = (id: string) => {
        const newValue = expanded == id ? '' : id
        setExpanded(newValue);
    };

    const getActiveOrLatestTransaction = (transactions: any[]) => {
        if (!Array.isArray(transactions) || transactions.length === 0) return null;
        // 1. Prioritize active / trialing transaction with a stripe ID
        const activeWithStripe = transactions.find((t: any) => t.stripe && t.active === true && (t.status === 'active' || t.status === 'trialing'));
        if (activeWithStripe) return activeWithStripe;

        // 2. Prioritize any active transaction
        const anyActive = transactions.find((t: any) => t.active === true && t.status !== 'canceled');
        if (anyActive) return anyActive;

        // 3. Fallback to newest transaction sorted by createdAt or _id
        const sorted = [...transactions].sort((a: any, b: any) => {
            const timeA = new Date(a.createdAt || 0).getTime();
            const timeB = new Date(b.createdAt || 0).getTime();
            return timeA - timeB;
        });
        return sorted[sorted.length - 1];
    };

    const validateSubscriptionStatus = async (u: any, activeCredit: any) => {
        try {
            const txResult = await filterTransaction({ user: u._id });
            const transactionData = getActiveOrLatestTransaction(txResult);
            if (transactionData && transactionData.stripe) {
                const stripeId = transactionData.stripe;
                const stripeResult = await verificarStatusCliente({ id: stripeId });
                console.log('Stripe Verification Result API:', stripeResult);
                if (stripeResult && (stripeResult.status === 'erro' || stripeResult.status === 'canceled' || stripeResult.status === 'incomplete' || stripeResult.status === 'incomplete_sofort')) {
                    // Check if there is another active transaction before downgrading
                    const hasOtherActive = Array.isArray(txResult) && txResult.some((t: any) => 
                        t._id !== transactionData._id && t.active === true && (t.status === 'active' || t.status === 'trialing')
                    );
                    if (hasOtherActive) {
                        console.log('User has another active transaction, skipping downgrade.');
                        return;
                    }

                    Notifications({
                        type: 'warning',
                        message: 'Your Premium subscription could not be verified or has expired. You are now on the Free plan. Please resubscribe.',
                        title: 'Premium Required',
                        timeOut: 6000,
                        priority: true,
                        callback: () => {}
                    });
                    
                    setReferralsRemaining(3 - referralsRequested); 
                    
                    const updateData = {
                        _id: activeCredit._id,
                        amount: 3,
                        amountPdf: 3,
                        amountInterview: 1,
                        amountVisa: 3,
                        type: 'free',
                        status: 'active',
                    };
                    const updateTransactionData = {
                        _id: transactionData._id,
                        planType: 'free',
                        status: 'free',
                        stripe: ''
                    };
                    
                    await UpdateCreditMutation({
                        variables: { updateCreditInput: updateData }
                    });
                    
                    await UpdateTransactionMutation({
                        variables: { updateTransactionInput: updateTransactionData }
                    });
                    console.log('Credit and Transaction restored to free plan limits due to expired subscription.');
                }
            }
        } catch(error) {
            console.log('Error verifying subscription status', error)
        }
    }
    const apiRef = useGridApiRef();

    const checkCredit = async (u: any) => {
        setLoading(true)

        // Fetch fresh user data to get currentPlan from backend
        let currentUser = u;
        try {
            const freshUser = await whoami();
            if (freshUser) {
                currentUser = freshUser;
            }
        } catch (e) {
            console.log('Error fetching fresh user details in checkCredit', e);
        }

        // Verify active transaction to determine correct planType
        let resolvedPlanType = 'free';
        try {
            const txResult = await filterTransaction({ user: currentUser._id });
            const latestTx = getActiveOrLatestTransaction(txResult);
            if (latestTx) {
                resolvedPlanType = latestTx.planType || 'free';
                
                if (latestTx.stripe) {
                    const stripeResult = await verificarStatusCliente({ id: latestTx.stripe });
                    if (stripeResult && (stripeResult.status === 'erro' || stripeResult.status === 'canceled' || stripeResult.status === 'incomplete' || stripeResult.status === 'incomplete_sofort')) {
                        const hasOtherActive = Array.isArray(txResult) && txResult.some((t: any) => 
                            t._id !== latestTx._id && t.active === true && (t.status === 'active' || t.status === 'trialing')
                        );
                        if (!hasOtherActive) {
                            resolvedPlanType = 'free';
                        }
                    } else if (stripeResult && (stripeResult.status === 'active' || stripeResult.status === 'trialing')) {
                        resolvedPlanType = latestTx.planType || 'basic';
                    }
                }
            }
        } catch (error) {
            console.log('Error verifying active transaction on checkCredit:', error);
            resolvedPlanType = currentUser.currentPlan || 'free';
        }

        const objToSend = {
            "active" : true,
            "user": currentUser._id || '',
        }
        console.log('objToSend', objToSend)

        const result = await filterCredit(objToSend)
        console.log('filterCredit result ==>', result)
        if (!Array.isArray(result)) {
            setLoading(false)
            checkRecommendations(u)
            return
        }
        const creditsLength = result.length;
        if ( creditsLength == 0) {
            console.log('call add credit with plan:', resolvedPlanType)
            handleAddCredit(resolvedPlanType)
        } else {
            // Find the credit with the latest expiration (current cycle)
            let creditActual: any = result[0]
            for (const credit of result) {
              if (credit.expiration && (!creditActual.expiration || new Date(credit.expiration) > new Date(creditActual.expiration))) {
                creditActual = credit
              }
            }

            // Auto-heal: If user has an active paid subscription (e.g. basic or plus) but credit was marked free
            if (resolvedPlanType !== 'free' && creditActual.type === 'free') {
                const planDetails = resolvedPlanType === 'plus'
                    ? { amount: 30, amountPdf: 10, amountInterview: 5, amountVisa: 10 }
                    : { amount: 10, amountPdf: 5, amountInterview: 3, amountVisa: 5 };

                try {
                    const updateData = {
                        _id: creditActual._id,
                        ...planDetails,
                        type: resolvedPlanType,
                        status: 'active',
                    };
                    await UpdateCreditMutation({
                        variables: { updateCreditInput: updateData }
                    });
                    creditActual = { ...creditActual, ...updateData };
                    console.log(`Credit restored to ${resolvedPlanType} plan limits based on active subscription.`);
                } catch (updateCreditErr) {
                    console.log('Error restoring paid credit:', updateCreditErr);
                }
            }

            setCredit(creditActual)
            const requested = creditActual.recommendations?.length || 0
            setReferralsRequested(requested)
            setReferralsRemaining(creditActual.amount - requested)
            validateSubscriptionStatus(u, creditActual);
        }
        setLoading(false)
        checkRecommendations(u)
    }
    const checkRecommendations = async (u: any) => {
        setLoading(true)
        const objToSend = {
            //startDate,
            //endDate,
            //empresa:empresa
            //category:selectedCategory?._id || '',
            "scout": u._id || '',
            "active": true,
            //"type": 'scoutme'

        }
        //setIsLoadingCompaniesByFilter(true)
        console.log('objToSend recommendations', objToSend)

        const result: any = await filterRecommendation(objToSend)
        console.log('filterRecommendation result ==>>', result)
        if (result.length == 0) {
            console.log('call add credit')
            //handleAddRecommendations()
        } else {
            //setReferralsRemaining(result[0].amount)
            setRecommendations(result)
        }
        setLoading(false)
        
        //getProductsByFilter(objToSend)
        //getCompaniesByFilter(objToSend)
        //setIsLoadingCompaniesByFilter(false)
        //setCompanies(result)
        //setSelectedCategory({})
    }

    const getCategoriesAsync = async () => {

        const result: any = await getCategories()
        console.log('resutl ===>', result)

        if (result?.length) {
            setCategories(result)
        }
    }



    const getCompaniesAsync = async () => {

        const result: any = await getCompanies()
        console.log('resutl ===>', result)

        if (result?.length) {
            setCompanies(result)
        }
    }

    useEffect(() => {
        if (recommendations.length) {

            apiRef.current.setColumnVisibility('_id', false);
            setRows(recommendations)
        }


    }, [recommendations]);

    useEffect(() => {
        if (companies.length) {
            const localImageList: any = [];
            for (let i = 0; i < companies.length; i++) {
                const company = companies[i];
                if (company.image || company.logos.length) {
                    const imageListItem = {
                        description: company.description,
                        name: company.name,
                        url: company.image && company.image.indexOf('http') == -1 && company.image && company.image.indexOf('svg') == -1 ? serverConfig.dev.url + 'images/' + company.image : company.logos[1]?.url && company.logos[1]?.url?.indexOf('data:image') == -1 ? company.logos[1]?.url : company.logos[0]?.url
                    };
                    localImageList.push(imageListItem);
                }
            }
            setImagesList(localImageList);
        }

    }, [companies]);
    useEffect(() => {
        //getUsuarios();
        getCategoriesAsync();
        getCompaniesAsync();

    }, []);
    useEffect(() => {
        if (user?._id) {
            checkCredit(user)
        }

    }, [user]);



    const getUsuarios = async () => {

        const result = await getUsers()
        const users = result
        console.log(users)
        if (users.length) {
            setUsuarios(users)
        }
    }
    useEffect(() => {
        if (isLoadingUsuarios) {
            setLoading(true)
        }
        if (loading && !isLoadingUsuarios) {
            getUsuarios();
            setLoading(false)
        }
        console.log('isLoadingUsuarios ==> ', isLoadingUsuarios)

    }, [isLoadingUsuarios]);

    useEffect(() => {
        if (isLoadingCreateUsuario) {
            setLoading(true)
        }
        if (loading && !isLoadingCreateUsuario) {
            getUsuarios();
            setLoading(false)
        }
        console.log('isLoadingCreateUsuario ==> ', isLoadingCreateUsuario)

    }, [isLoadingCreateUsuario]);

    const handleDeleteClick = (UsuarioId: any) => {
        console.log('UsuarioId', UsuarioId)
        setSelectedUsuario(UsuarioId);
        setDeleteConfirmationOpen(true);
    };

    const handleDeleteConfirmation = () => {
        console.log('selectedUsuario', selectedUsuario)
        //deleteUsuario(selectedUsuario);
        setDeleteConfirmationOpen(false);
    };

    const clearNewUsuario = () => {
        setNewUsuarioName('');
        setNewUsuarioEmail('');
        setNewUsuarioTelefone('');
        setNewUsuarioEmpresa('');
        setNewUsuarioPassword('');
        setNewUsuarioConfirmPassword('');

    }

    const makePermissoes = () => {
        if (newUsuarioPermissoes == 'administrador') {
            return { admin: true }
        } else if (newUsuarioPermissoes == 'basico') {
            return { basic: true }
        } else if (newUsuarioPermissoes == 'gerente') {
            return { manager: true }
        } else {
            return {}
        }
    }

    const handleAddUsuario = () => {
        const novaUsuario = {
            nome: newUsuarioName,
            email: newUsuarioEmail,
            password: newUsuarioPassword,
            confirmPassword: newUsuarioConfirmPassword,
            empresa: newUsuarioEmpresa || '635c074796a268680647cdff',
            permissoes: makePermissoes(),
            ativo: true,
        };
        console.log('novaUsuario', novaUsuario)
        //createUsuario(novaUsuario);
        setAddUsuarioModalOpen(false);
        clearNewUsuario()
    };


    const validateEmail = (email: any) => {
        return true
        // Implemente a lógica de validação do e-mail aqui
    };






    const validatePhone = (phone: any) => {
        // Remove caracteres não numéricos
        phone = phone.replace(/[^\d]+/g, '');

        // Verifica se possui 11 dígitos (considerando o DDD)
        if (phone.length !== 11) {
            return false;
        }

        // Verifica se todos os dígitos são iguais (ex: 00000000000)
        if (/^(\d)\1+$/.test(phone)) {
            return false;
        }

        return true;
    };

    const maskPhone = (phone: any) => {
        // Remove caracteres não numéricos
        phone = phone.replace(/[^\d]+/g, '');

        // Aplica a máscara
        phone = phone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');

        return phone;
    };

    const handleEditUsuario = (usuario: any) => {
        console.log('usuario selecionada ==>> ', usuario)
        let perm = 'basico'
        if (usuario.permissoes?.admin) {
            perm = 'administrador'
        } else if (usuario.permissoes?.manager) {
            perm = 'gerente'
        }
        setNewUsuarioPermissoes(perm)
        setPasswordOpen(false);
        setNewUsuarioPassword('')
        setNewUsuarioConfirmPassword('')
        setEditUsuarioData(usuario);
        setEditUsuarioModalOpen(true);
    };

    const handleUpdateUsuario = () => {
        console.log(newUsuarioPassword)
        const dataToSend = { ...editUsuarioData }
        if (!newUsuarioPassword) {
            console.log('editUsuarioData', editUsuarioData)
            delete dataToSend.password
        }
        dataToSend.permissoes = makePermissoes();
        console.log('dataToSend', dataToSend)
        //updateUsuario(dataToSend)
        setEditUsuarioData({});
        setEditUsuarioModalOpen(false);
        // Lógica para atualizar a Usuario com os dados do modal
    };

    const validatePassword = (password: string | any[]) => {
        return password.length >= 6;
    };

    const validateConfirmPassword = (password: any, confirmPassword: any) => {
        return password === confirmPassword;
    };



    //init DataGrid dependencies

    const clearData = (d: any) => {
        const dateTransform = (moment(d).format('DD-MM-YYYY h:m'));
        return dateTransform
    }

    const handleRowEditStop: GridEventListener<'rowEditStop'> = (params, event) => {
        if (params.reason === GridRowEditStopReasons.rowFocusOut) {
            event.defaultMuiPrevented = true;
        }
    };

    const handleEditClick = (id: GridRowId) => () => {
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
    };

    interface EditToolbarProps {
        setRows: (newRows: (oldRows: GridRowsProp) => GridRowsProp) => void;
        setRowModesModel: (
            newModel: (oldModel: GridRowModesModel) => GridRowModesModel,
        ) => void;
    }

    const _ = (id: GridRowId) => () => {
        setRows(rows.filter((row: any) => row._id !== id));
    };

    const handleCancelClick = (id: GridRowId) => () => {
        setRowModesModel({
            ...rowModesModel,
            [id]: { mode: GridRowModes.View, ignoreModifications: true },
        });

        const editedRow = rows.find((row: any) => row._id === id);
        if (editedRow!.isNew) {
            setRows(rows.filter((row: any) => row._id !== id));
        }
    };

    const processRowUpdate: any = (newRow: GridRowModel) => {
        const updatedRow = { ...newRow, isNew: false };
        console.log('newRow', newRow)
        if (newRow.isNew) {
            delete newRow.isNew
        }
        setEditUsuarioData(newRow)
        setRows(rows.map((row: any) => (row._id === newRow._id ? updatedRow : row)));
        return updatedRow;
    };

    const handleRowModesModelChange = (newRowModesModel: GridRowModesModel) => {
        setRowModesModel(newRowModesModel);
    };

    const checkPermissao = (perm: any) => {
        let permString = ''
        if (perm.admin) {
            permString = 'administrador'
        } else if (perm.manager) {
            permString = 'gerente'
        } else {
            permString = 'operador'
        }
        return permString

    }



    const getProfileByUserAsync = async (userId: any) => {
        try {
            setLoading(true)
            const profile: any = await findProfileByUser(userId);
            console.log('profile ==>>', profile)
            setLoading(false)
            setEditUsuarioData(profile)
        }
        catch (error) {
            console.log("Erro no getUser >>>>>", error)
        }
    }

    const getChatgptAsync = async (userResume: any) => {
        const result: any = await filterChatgpt({ user: userResume._id, type: "airesumefeedback" })
        if (result?.length) {
            const defaultRecord = result.find((r: any) => r.isDefault === true)
            const airesumefeedback = defaultRecord || result[result.length - 1]
            const res = airesumefeedback.response
            setFavoriteFeedback(airesumefeedback)
            setDefaultPdf(airesumefeedback.pdf || '')
            makeFinalResult(res)
        } else {
            setFavoriteFeedback(null)
            setDefaultPdf('')
            setFinalResult('')
        }
    }

    const makeBullets = (obj: any) => {
        let resp = ''
        if (obj) {
            for (var i in obj) {
                const valor = obj[i]
                if (typeof valor == 'object') {
                    resp += `* ${i}: <br>`
                    resp += makeBullets(valor)
                } else {
                    resp += `* ${i}: ${valor} <br>`
                }
            }
        }
        return resp;
    }

    const makeFinalResult = (res: any) => {
        let resObj
        let final = ''
        if (res) {
            try {
                resObj = JSON.parse(res)
            } catch (e) {
                console.error('Error parsing AI response:', e);
                setFinalResult(`<p style="color: red;">Error: Could not parse AI response. Raw response: ${res}</p>`);
                return;
            }
            if (resObj) {
                for (var i in resObj) {
                    if (i === 'grade') continue;
                    const valor: any = resObj[i]
                    final += '<h3 style="color: #00FFFF; margin-top: 18px; margin-bottom: 8px; font-weight: 600; text-transform: capitalize; border-bottom: 1px solid rgba(138, 46, 226, 0.2); padding-bottom: 4px;">' + i + "</h3>"
                    if (typeof valor == 'object') {
                        final += makeBullets(valor)
                    } else {
                        final += valor
                    }
                    final += '<br>'
                }
            }
            setFinalResult(final)
        }
    }

    function CircularProgressWithLabel(
        props: any,
    ) {
        return (
            <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                <CircularProgress variant="determinate" {...props} />
                <Box
                    sx={{
                        top: 0,
                        left: 0,
                        bottom: 0,
                        right: 0,
                        position: 'absolute',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Typography
                        variant="caption"
                        component="div"
                        style={{ color: '#ffffff', fontWeight: 600 }}
                    >{`${Math.round(props.value)}%`}</Typography>
                </Box>
            </Box>
        );
    }

    const showRequest = async (refer: any) => {

        console.log('refer==>', refer)
        //return;
        setReferralData(refer.referral)
        const recom = refer
        console.log('recom', recom)
        await getProfileByUserAsync(refer.scout._id)
        await getChatgptAsync(refer.scout)
        setSelectedRecommendation(recom)
        setSelectedScout(user)
        setRequestPanel(true)
        setOpenReferral(true)
        //handleAddReferral(recom)
        //setRequestPanel(true)

    }
    const showRequestProposal = async (recom: any) => {


        console.log('recom', recom)
        await getProfileByUserAsync(recom.scout._id)
        setSelectedRecommendation(recom)
        setSelectedScout(user)
        setRequestProposalPanel(true)


    }


    const columns: GridColDef[] = [
        { field: '_id', headerName: 'ID', width: 90 },
        {
            field: 'createdAt',
            headerName: 'Date',
            type: 'Date',
            width: 140,
            editable: false,
            valueGetter: (params: GridValueGetterParams) => clearData(params.row.createdAt)
        },

        {
            field: 'company',
            headerName: 'Company',
            width: 150,
            editable: true,
            valueGetter: (params: GridValueGetterParams) => params.row.company?.name || ""
        },
        {
            field: 'scouter',
            headerName: 'Scouter',
            width: 150,
            editable: true,
            valueGetter: (params: GridValueGetterParams) => params.row.scouter?.name || ""
        },
        {
            field: 'link',
            headerName: 'Job link',
            width: 150,
            editable: true,
            //valueGetter : (params: GridValueGetterParams)=> getCategoriaNome(params.row.categoria)
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 150,
            editable: false,
            //valueGetter: (params: GridValueGetterParams) => params.row.role || ''
        },

        {
            field: 'details',
            headerName: 'Details',
            width: 120,
            editable: false,
            valueGetter: (params: GridValueGetterParams) => params.row.details || ''
        },



        /* {
          field: 'identificacao',
          headerName: 'código',
          description: 'código do item',
          sortable: false,
          width: 140,
          valueGetter: (params: GridValueGetterParams) =>
            `${params.row.identificacao[0].codigo || ''}  `,
        }, 
        {
          field: 'updatedAt',
          headerName: 'tipo identificacao',
          description: 'tipo de identificacao',
          sortable: false,
          width: 75,
          valueGetter: (params: GridValueGetterParams) =>
            `${params.row.identificacao[0].tipo || ''} `,
        }, */
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            width: 150,
            cellClassName: 'actions',
            getActions: ({ id }) => {
                const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
                const cat = usuarios.filter((item: any) => item._id == id)[0]
                const item = rows.filter((item: any) => item._id == id)[0]
                if (isInEditMode) {
                    return [
                        <GridActionsCellItem
                            icon={<SaveIcon />}
                            label="Save"
                            sx={{
                                color: 'primary.main',
                            }}
                        //onClick={handleSaveClick(id)}
                        />,
                        <GridActionsCellItem
                            icon={<CancelIcon />}
                            label="Cancel"
                            className="textPrimary"
                            onClick={handleCancelClick(id)}
                            color="inherit"
                        />,
                    ];
                }
                return [



                    <GridActionsCellItem
                        icon={
                            item.status == 'Under Review' && item.type == 'scoutingpool'&&item.details!="Under Review by Scouter" ?
                                <Tooltip TransitionComponent={Zoom} title="View request" arrow>
                                    <IconButton className='iconDetail' color="primary" aria-label="Details" >
                                        <AppRegistrationIcon />
                                    </IconButton>
                                </Tooltip> :
                                <Tooltip TransitionComponent={Zoom} title="Details" arrow>
                                    <IconButton className='iconDetail' color="primary" aria-label="Details" >
                                        <ViewHeadline />
                                    </IconButton>
                                </Tooltip>

                        }
                        label="Details"
                        className="textPrimary"
                        onClick={() => {

                            if (item.status == 'Under Review' && item.type == 'scoutingpool'&&item.details!="Under Review by Scouter") {
                                showRequestProposal(item)
                                return
                            }
                            if (item.status == 'Under Review') {
                                const notData = {
                                    type: 'success',
                                    message: `Your referral has been made to ${item.company.name} members and is awaiting feedback.`,
                                    title: 'wescout',
                                    timeOut: 1000,
                                    callback: () => { },
                                    priority: true,
                                }

                                return Notifications(notData)
                            }
                            showRequest(item)
                            //console.log(item)
                        }}
                        color="inherit"
                    />,

                ];
            },
        },


    ];

    const hiddenFields = ['_id', 'id', 'ID'];

    const getTogglableColumns = (columns: GridColDef[]) => {
        console.log('getTogglableColumns', columns)
        return columns
            .filter((column) => !hiddenFields.includes(column.field))
            .map((column) => column.field);
    };

    const changeFilter = async (cat?: any) => {
        const referencia = cat || selectedCategory
        const objToSend = {
            startDate,
            endDate,
            //empresa:empresa
            category: referencia?._id || '',
            //usuario : selectedUser?._id || '',

        }
        //setIsLoadingCompaniesByFilter(true)
        console.log('objToSend', objToSend)

        const result = await filterCompany(objToSend)
        console.log('filter result ==>>', result)
        //getProductsByFilter(objToSend)
        //getCompaniesByFilter(objToSend)
        //setIsLoadingCompaniesByFilter(false)
        setCompanies(result)
        //setSelectedCategory({})
    }

    const changeCategory = (cat: any) => {
        console.log(cat)
        changeFilter(cat)
    }
    const handleSendLink = () => {
        console.log()
    }


    const handleUpdateCredit = async ()=>{
        const dataToSend = {
            _id: credit._id,
            recommendationId : selectedRecommendation._id
        }
        console.log('handleUpdateCredit dataToSend', dataToSend)

        // dataToSend.id = dataToSend._id

        //return;

        try {

            const updateCreditInput = dataToSend
            console.log('updateCreditInput', dataToSend)

            const result = await UpdateCreditMutation({
                variables: {
                    updateCreditInput
                },
                onCompleted: ({ createCredit }) => {

                    console.log('company created== > ', createCredit);
                    const notData = {
                        type: 'success',
                        message: `Created Successfully!`,
                        title: 'wescout',
                        timeOut: 1500,
                        callback: () => { },
                        priority: true,
                    }

                    Notifications(notData)
                    checkCredit(user)

                    //navigate('/login')
                    //setCompany(updateUser);
                }
            });
        } catch (error: any) {
            const notData = {
                type: 'error',
                message: error.message,
                title: 'wescout',
                timeOut: 2500,
                callback: () => { },
                priority: true,
            }
            Notifications(notData)
            console.log("Error at create credit", error)

        }
    }

    const updateMutation = async () => {
        setLoading(true);
        const dataToSend = {
          _id: selectedRecommendation._id,
          status: "Under Review",
          details: 'Under Review by Scouter',
          detailsScouter: 'Need your action',
          //referral: referralId,
          //scouter: user._id
        }
        try {
    
          const updateRecommendationInput = dataToSend
          console.log('updateRecommendationInput', dataToSend)
    
          const result = await UpdateRecommendationMutation({
            variables: {
              updateRecommendationInput
            },
            onCompleted: ({ updateRecommendation }) => {
    
              console.log('updateRecommendation== > ', updateRecommendation);
              const notData = {
                type: 'success',
                message: `Referral to ${updateRecommendation?.company?.name} Created Successfully!`,
                title: 'wescout',
                timeOut: 1000,
                callback: () => { },
                priority: true,
              }
              //checkReferrals(user)
              //Notifications(notData)
              setLoading(false);
              handleUpdateCredit()
              //checkRecommendations(user)
              //navigate('/scout')
              //setCompany(updateUser);
            }
          });
        } catch (error: any) {
          const notData = {
            type: 'error',
            message: error.message,
            title: 'wescout',
            timeOut: 2500,
            callback: () => { },
            priority: true,
          }
          Notifications(notData)
          console.log("Error at updateRecommendation", error.message)
          setLoading(false);
        }
      }

    const acceptRecommendation = ()=>{
        console.log('acceptRecommendation', selectedRecommendation)
        
        if (referralsRemaining <= 0) {
            Notifications({
                type: 'error',
                message: 'You do not have enough credits to accept this recommendation. Please go to Scout me to purchase more.',
                title: 'Insufficient Credits',
                timeOut: 5000,
                priority: true,
                callback: () => {}
            });
            return;
        }

        updateMutation()
        setRequestProposalPanel(false)
    }
    const denyRecommendation = ()=>{
        console.log('denyRecommendation')
        setRequestProposalPanel(false)
    }





    return (
        <Container className={classes.container}>
            <div className={classes.root}>
                <div className={classes.content}>
                    {/* <Button className='backbutton' onClick={() => navigate(-1)}>Go Back</Button> */}

                    {/* <Button className={classes.addButton} variant="contained" color="primary" startIcon={<AddIcon />} onClick={() => setAddUsuarioModalOpen(true)}>
            add user
          </Button> */}

                    {loading ? (
                        <Box sx={{ width: '100%' }}>
                            <LinearProgress />
                        </Box>
                    ) : null}
                    <Box sx={{ width: '100%', height: 30, paddingTop: '15px' }}>
                        <Stack borderRadius={15} spacing={2} direction="column" alignItems={'center'} alignContent={'center'} >
                            <Typography className={'title'}>
                                Referrals you’ve requested
                            </Typography>
                        </Stack>
                    </Box>
                    <Box sx={{ width: '100%', height: 80, }} style={{
                        padding: '10px', paddingBottom: '10px',
                        borderColor: 'green',
                        borderWidth: '2px',
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'nowrap',
                        alignContent: 'center',
                        justifyContent: 'space-evenly',
                        alignItems: 'center'
                    }}
                    >

                        <Button onClick={() => {
                            const notData = {
                                type: 'success',
                                message: `Request a referral now! Go to Scout me page`,
                                title: 'wescout',
                                timeOut: 1000,
                                callback: () => { },
                                priority: true,
                            }

                            return Notifications(notData)
                        }} variant="contained" className='button-referral'  >
                            Referrals Remaining
                            <Avatar sx={{ bgcolor: '#0df228' }} aria-label="recipe">
                                {referralsRemaining}
                            </Avatar>

                        </Button>
                        <Button variant="contained" className='button-referral'  >
                            Referrals Requested
                            <Avatar sx={{ bgcolor: '#0df228' }} aria-label="recipe">
                                {referralsRequested}
                            </Avatar>

                        </Button>
                    </Box>
                    <Box sx={{ width: '100%', height: 100, }} style={{ alignSelf: 'center', paddingTop: 10, paddingBottom: 10, borderColor: 'green', borderWidth: 2 }}>
                        <Button  onClick={() => navigate('/usuario')}>Complete your profile</Button>
                        {/* <Stack borderRadius={15} spacing={2} direction="column" alignItems={'center'} alignContent={'center'} divider={<Divider orientation="vertical" flexItem />}>
                            <Box sx={{ width: '100%' }} style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', height: 30, alignContent: 'center', justifyContent: 'space-around', alignSelf: 'center', paddingTop: 10, paddingBottom: 10, borderColor: 'green', borderWidth: 2 }}>
                                <Autocomplete
                                    getOptionLabel={(cat: any) => cat.name}
                                    //getOptionSelected={(option:any, value:any) => option.nome === value.nome }
                                    onChange={(event, newValue) => {
                                        console.log(newValue)


                                        if (!newValue) {
                                            setSelectedCategory({})
                                            changeCategory({})

                                        }
                                        setSelectedCategory(newValue)
                                        changeCategory(newValue)
                                        //getInventoriesByCategory(newValue._id)
                                    }}
                                    disablePortal
                                    id="combo-box-demo"
                                    options={categories}
                                    sx={{ width: 300 }}
                                    renderInput={(params: any) => <TextField {...params} label="Category" />}
                                />
                                <Autocomplete
                                    getOptionLabel={(usu: any) => usu.name}
                                    //getOptionSelected={(option:any, value:any) => option.nome === value.nome }
                                    onChange={(event, newValue) => {
                                        console.log(newValue)
                                        setSelectedCompany(newValue)
                                        //changeFilter()

                                    }}
                                    disablePortal
                                    id="combo-box-usuario"
                                    options={companies}
                                    sx={{ width: 300 }}
                                    renderInput={(params: any) => <TextField {...params} label="Company" />}
                                />

                            </Box>

                           







                        </Stack> */}
                    </Box>


                    {recommendations.length ? (
                        <div className={classes.listContainer}>

                            <DataGrid
                                apiRef={apiRef}
                                loading={isLoadingUsuarios || isLoadingUsuariosByFilter}
                                getRowId={(row: { _id: any; }) => row._id}
                                //checkboxSelection
                                disableRowSelectionOnClick

                                onClipboardCopy={(copiedString) => console.log(copiedString)}
                                unstable_ignoreValueFormatterDuringExport
                                autoHeight={true}
                                rows={rows}
                                columns={columns}
                                initialState={{
                                    sorting: {
                                        sortModel: [{ field: 'createdAt', sort: 'asc' }],
                                    },

                                    pagination: {
                                        paginationModel: {
                                            pageSize: 15,
                                        },
                                    },
                                }}
                                pageSizeOptions={[5]}
                                //checkboxSelection

                                //editMode="row"
                                rowModesModel={rowModesModel}
                                onRowModesModelChange={handleRowModesModelChange}
                                onRowEditStop={handleRowEditStop}
                                processRowUpdate={processRowUpdate}
                                // slots={{
                                //   toolbar: EditToolbar,
                                // }}
                                slots={{ toolbar: GridToolbar }}
                                slotProps={{
                                    toolbar: {
                                        setRows, setRowModesModel, csvOptions: {
                                            fileName: 'usuariosDataBase_',
                                            delimiter: ';',
                                            utf8WithBom: true,
                                        },
                                        columns: {
                                            columnVisibilityModel: { ID: false, },
                                        },
                                        columnsPanel: {
                                            getTogglableColumns,
                                        },
                                        printOptions: { hideToolbar: true, disableToolbarButton: false }
                                    },
                                }}



                            //toolbar: { printOptions: { getRowsToExport: getSelectedRowsToExport } },


                            />

                        </div>
                    ) : (<Box>
                        <Typography paragraph>
                            Request a referral now
                        </Typography>
                        <Button onClick={() => navigate('/scoutme')}>Scout me</Button>
                    </Box>)}
                    
                    {/* {usuarios.length ? (
            <div className={'listContainer'}>
              <List>
                {usuarios.map((usuario: any, index: any) => (
                  <ListItem key={index} className={classes.listItem} divider>
                    <Typography className='text'>{usuario.nome}</Typography>
                    <div>
                      <IconButton color="primary" aria-label="Editar" onClick={() => handleEditUsuario(usuario)}>
                        <EditIcon />
                      </IconButton>
                      
                      <IconButton
                        color="secondary"
                        aria-label="Deletar"
                        className={classes.deleteButton}
                        onClick={() => handleDeleteClick(usuario._id)}
                      >
                        
                        <DeleteIcon />
                      </IconButton>
                    </div>
                  </ListItem>
                ))}
              </List>
            </div>
            
          ) : null} */}
                    {/* <Button className='backbutton' onClick={() => navigate(-1)}>Go Back</Button> */}
                </div>
                
                    <Typography variant="h5" className={'title'} style={{ marginTop: 10,marginBottom: 4, textAlign: 'center' }}>
                       We have representatives from these companies excited to refer you
                    </Typography>
                     {imagesList.length > 0 && <ImageCarousel images={imagesList} />}
                
            </div>
        
            <Dialog fullWidth={true} style={{  margin: "0 auto" }} open={requestProposalPanel} onClose={() => {
                setRequestProposalPanel(false)
                //setOpenReferralPro(false)
            }} >

                <DialogTitle>Accept or deny this request - complete the following information </DialogTitle>

                <DialogContent className={'modalContent'}>
                    <Typography variant="h4">{selectedRecommendation?.company?.name || ""}</Typography>

                    {/* <Typography variant="body1">E-mail of {selectedRecommendation.company?.name || ""} HR</Typography> */}

                    <>


                        <Typography variant="body2">send at: {clearData(selectedRecommendation.createdAt)}</Typography>
                        {/* <Typography variant="body1">Thank you for your referral!</Typography> */}
                        <Typography variant="body2">send by: {selectedRecommendation?.scouter?.name}</Typography>
                        <Typography variant="body2">message: {selectedRecommendation.message}</Typography>
                    </>


      
                    <div>
                        
                       
                        <Divider />
                        {/* <CircularProgressWithLabel style={{ margin: 15 }} value={80} /> */}
                        <Divider />
                        <div style={{ fontSize: 18, margin: 15 }}>
                            <Link href={`${selectedRecommendation.link}`} target="_blank" underline="hover">
                                {'Job link'}
                            </Link>

                        </div>

                        {referralsRemaining <= 0 ? (
                            <Typography color="error" style={{ fontWeight: 'bold', marginTop: 10 }}>
                                You do not have enough credits to accept this proposal. Please purchase more credits.
                            </Typography>
                        ) : (
                            <Typography>
                                By accepting this proposal, your referral will be sent to the company's HR department. This accept will be consumed 1 credit.
                            </Typography>
                        )}

                        {/* {limit ? (<CircularProgressWithLabel style={{ margin: 15 }} value={progress} />) : null} */}


                    </div>
                </DialogContent>
                <DialogActions>
                    

                        <Button variant='outlined' color='primary' disabled={referralsRemaining <= 0} onClick={() => {
                            acceptRecommendation()
                        }}>Accept</Button>
                        <Button color="secondary" variant='outlined' onClick={() => {
                            denyRecommendation()
                        }}>Deny</Button>
                        <Button onClick={() => setRequestProposalPanel(false)}>Cancel</Button>
                    
                </DialogActions>
            </Dialog>
            <Modal open={requestPanel} onClose={() => {
                setRequestPanel(false);
                setOpenReferral(false);
            }} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                <div style={{
                    backgroundColor: '#0a0a0a',
                    color: '#ffffff',
                    width: isMobile ? '95%' : '90%',
                    maxWidth: '1350px',
                    maxHeight: '90vh',
                    borderRadius: '16px',
                    border: '1px solid rgba(138, 46, 226, 0.3)',
                    boxShadow: '0 8px 32px 0 rgba(0, 255, 255, 0.15)',
                    display: 'flex',
                    flexDirection: 'column',
                    outline: 'none',
                    fontFamily: '"Outfit", "Inter", sans-serif',
                    overflow: 'hidden'
                }}>
                    {/* Modal Header */}
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '16px 24px',
                        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                        backgroundColor: '#111115'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                            <Avatar 
                                src={selectedScout?.image ? serverConfig.dev.url + 'images/' + selectedScout.image : "https://robohash.org/" + (selectedScout?.name || "avatar")}
                                style={{ width: '48px', height: '48px', border: '2px solid #00FFFF', boxShadow: '0 0 10px rgba(0, 255, 255, 0.3)' }}
                            />
                            <div style={{ textAlign: 'left' }}>
                                <h2 style={{ margin: 0, fontSize: '20px', fontWeight: 700, color: '#ffffff' }}>
                                    Referral Receipt - {selectedRecommendation?.company?.name || 'Company'}
                                </h2>
                                <span style={{ fontSize: '14px', color: '#00FFFF', fontWeight: 500 }}>
                                    Your application has been referred to HR
                                </span>
                            </div>
                        </div>
                        <Button 
                            onClick={() => {
                                setRequestPanel(false);
                                setOpenReferral(false);
                            }} 
                            style={{ 
                                color: '#ffffff', 
                                borderColor: 'rgba(255,255,255,0.3)',
                                backgroundColor: 'rgba(255,255,255,0.05)',
                                padding: '6px 16px',
                                textTransform: 'uppercase',
                                fontWeight: 600,
                                fontSize: '12px'
                            }}
                            variant="outlined"
                        >
                            Close
                        </Button>
                    </div>

                    {/* Modal Content - Scrollable */}
                    <div style={{
                        padding: '24px',
                        overflowY: 'auto',
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '24px',
                        backgroundColor: '#0a0a0a'
                    }}>
                        {/* Dynamic Two-Column Layout */}
                        <div style={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: '24px',
                            width: '100%',
                            alignItems: 'stretch'
                        }}>
                            {/* Left Column: Receipt details and Candidate info */}
                            <div style={{
                                flex: isMobile ? '1 1 100%' : '0 0 38%',
                                maxWidth: isMobile ? '100%' : '38%',
                                minWidth: 0,
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '20px'
                            }}>
                                {/* Receipt card */}
                                <div style={{
                                    backgroundColor: '#111115',
                                    borderRadius: '12px',
                                    padding: '20px',
                                    border: '1px solid rgba(0, 255, 255, 0.3)',
                                    boxShadow: '0 0 10px rgba(0, 255, 255, 0.05)',
                                    textAlign: 'left'
                                }}>
                                    <h3 style={{ margin: '0 0 16px 0', color: '#00FFFF', fontSize: '18px', fontWeight: 600, borderBottom: '1px solid rgba(0, 255, 255, 0.2)', paddingBottom: '8px' }}>
                                        Nomination Details
                                    </h3>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid rgba(255,255,255,0.05)', paddingBottom: '8px' }}>
                                            <span style={{ color: '#a0a0ab', fontSize: '14px' }}>Recipient HR Email</span>
                                            <span style={{ color: '#ffffff', fontWeight: 500 }}>{referralData?.email || 'N/A'}</span>
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid rgba(255,255,255,0.05)', paddingBottom: '8px' }}>
                                            <span style={{ color: '#a0a0ab', fontSize: '14px' }}>Nomination Date</span>
                                            <span style={{ color: '#ffffff', fontWeight: 500 }}>{clearData(referralData?.createdAt)}</span>
                                        </div>
                                        <div style={{ marginTop: '8px' }}>
                                            <span style={{ color: '#a0a0ab', fontSize: '14px', display: 'block', marginBottom: '6px' }}>Nomination Intro Message:</span>
                                            <p style={{ margin: 0, color: '#e4e4e7', fontSize: '14px', lineHeight: '1.6', backgroundColor: 'rgba(255, 255, 255, 0.02)', padding: '12px', borderRadius: '8px', borderLeft: '3px solid #8A2BE2', wordBreak: 'break-word', overflowWrap: 'anywhere' }}>
                                                {referralData?.message || 'No intro message text.'}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* Candidate Details */}
                                <div style={{
                                    backgroundColor: '#111115',
                                    borderRadius: '12px',
                                    padding: '20px',
                                    border: '1px solid rgba(138, 46, 226, 0.15)',
                                    textAlign: 'left'
                                }}>
                                    <h3 style={{ margin: '0 0 16px 0', color: '#8A2BE2', fontSize: '18px', fontWeight: 600, borderBottom: '1px solid rgba(138, 46, 226, 0.2)', paddingBottom: '8px' }}>
                                        Your Professional Profile Details
                                    </h3>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid rgba(255,255,255,0.05)', paddingBottom: '8px' }}>
                                            <span style={{ color: '#a0a0ab', fontSize: '14px' }}>Nowadays Location</span>
                                            <span style={{ color: '#ffffff', fontWeight: 500 }}>{editUsuarioData?.location || 'N/A'}</span>
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid rgba(255,255,255,0.05)', paddingBottom: '8px' }}>
                                            <span style={{ color: '#a0a0ab', fontSize: '14px' }}>Origin Location</span>
                                            <span style={{ color: '#ffffff', fontWeight: 500 }}>{selectedScout?.country || 'N/A'}</span>
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid rgba(255,255,255,0.05)', paddingBottom: '8px' }}>
                                            <span style={{ color: '#a0a0ab', fontSize: '14px' }}>Years of Experience</span>
                                            <span style={{ color: '#ffffff', fontWeight: 500 }}>{editUsuarioData?.yearsOfExperience ? `${editUsuarioData.yearsOfExperience} years` : 'N/A'}</span>
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid rgba(255,255,255,0.05)', paddingBottom: '8px' }}>
                                            <span style={{ color: '#a0a0ab', fontSize: '14px' }}>English Level</span>
                                            <span style={{ color: '#00FFFF', border: '1px solid #00FFFF', padding: '2px 8px', borderRadius: '12px', fontSize: '12px', fontWeight: 600 }}>{selectedScout?.englishLevel || 'N/A'}</span>
                                        </div>
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '8px' }}>
                                            {selectedScout?.employed ? (
                                                <span style={{ color: '#FF00FF', backgroundColor: 'rgba(255, 0, 255, 0.1)', padding: '2px 8px', borderRadius: '4px', border: '1px solid #FF00FF', fontSize: '12px', fontWeight: 600 }}>Employed</span>
                                            ) : (
                                                <span style={{ color: '#39FF14', backgroundColor: 'rgba(57, 255, 20, 0.1)', padding: '2px 8px', borderRadius: '4px', border: '1px solid #39FF14', fontSize: '12px', fontWeight: 600 }}>Open to Hire</span>
                                            )}
                                            {selectedScout?.opentorelocation && (
                                                <span style={{ color: '#00FFFF', backgroundColor: 'rgba(0, 255, 255, 0.1)', padding: '2px 8px', borderRadius: '4px', border: '1px solid #00FFFF', fontSize: '12px', fontWeight: 600 }}>Open to Relocate</span>
                                            )}
                                            {selectedScout?.uePassport && (
                                                <span style={{ color: '#FFFF00', backgroundColor: 'rgba(255, 255, 0, 0.1)', padding: '2px 8px', borderRadius: '4px', border: '1px solid #FFFF00', fontSize: '12px', fontWeight: 600 }}>UE Passport</span>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* Bio Summary */}
                                <div style={{
                                    backgroundColor: '#111115',
                                    borderRadius: '12px',
                                    padding: '20px',
                                    border: '1px solid rgba(138, 46, 226, 0.15)',
                                    textAlign: 'left'
                                }}>
                                    <h3 style={{ margin: '0 0 12px 0', color: '#8A2BE2', fontSize: '18px', fontWeight: 600, borderBottom: '1px solid rgba(138, 46, 226, 0.2)', paddingBottom: '8px' }}>
                                        Bio / Professional Summary
                                    </h3>
                                    <p style={{ margin: 0, color: '#e4e4e7', fontSize: '14px', lineHeight: '1.6', whiteSpace: 'pre-wrap' }}>
                                        {editUsuarioData?.bio || 'No professional summary listed.'}
                                    </p>
                                </div>

                                {/* Experience & Education details */}
                                <div style={{
                                    backgroundColor: '#111115',
                                    borderRadius: '12px',
                                    padding: '20px',
                                    border: '1px solid rgba(138, 46, 226, 0.15)',
                                    textAlign: 'left',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '16px'
                                }}>
                                    <div>
                                        <h3 style={{ margin: '0 0 8px 0', color: '#8A2BE2', fontSize: '16px', fontWeight: 600 }}>Education Background</h3>
                                        <p style={{ margin: 0, color: '#e4e4e7', fontSize: '14px', lineHeight: '1.5', whiteSpace: 'pre-wrap' }}>
                                            {editUsuarioData?.educationBackground || 'No education background listed.'}
                                        </p>
                                    </div>
                                    <div style={{ borderTop: '1px solid rgba(255, 255, 255, 0.05)', paddingTop: '12px' }}>
                                        <h3 style={{ margin: '0 0 8px 0', color: '#8A2BE2', fontSize: '16px', fontWeight: 600 }}>Experience Description</h3>
                                        <p style={{ margin: 0, color: '#e4e4e7', fontSize: '14px', lineHeight: '1.5', whiteSpace: 'pre-wrap' }}>
                                            {editUsuarioData?.description || 'No detailed experience listed.'}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* Right Column: AI Analysis & PDF CV Viewer */}
                            <div style={{
                                flex: isMobile ? '1 1 100%' : '1 1 62%',
                                minWidth: 0,
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '20px'
                            }}>
                                {/* AI Match Analysis */}
                                <div style={{
                                    backgroundColor: '#111115',
                                    borderRadius: '12px',
                                    padding: '24px',
                                    border: '1px solid rgba(0, 255, 255, 0.3)',
                                    boxShadow: '0 0 15px rgba(0, 255, 255, 0.05)',
                                    textAlign: 'left',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    height: '100%',
                                    minWidth: 0
                                }}>
                                    {/* Header */}
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid rgba(0, 255, 255, 0.2)', paddingBottom: '12px', marginBottom: '16px', flexWrap: 'wrap', gap: '12px' }}>
                                        <div>
                                            <h3 style={{ margin: 0, color: '#00FFFF', fontSize: '18px', fontWeight: 600 }}>
                                                AI Match Analysis
                                            </h3>
                                            <span style={{ fontSize: '12px', color: '#39FF14', fontWeight: 600, textTransform: 'uppercase', display: 'block', marginTop: '2px' }}>
                                                ★ Starred Feedback
                                            </span>
                                        </div>

                                        {/* Compatibility Score */}
                                        {favoriteFeedback?.grade ? (
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <CircularProgressWithLabel
                                                    value={Number(favoriteFeedback.grade) * 10}
                                                    size={50}
                                                    style={{ color: '#39FF14' }}
                                                />
                                                <span style={{ fontSize: '12px', color: '#a0a0ab', fontWeight: 500 }}>Compatibility Score</span>
                                            </div>
                                        ) : null}
                                    </div>

                                    {/* Job link and CV open button */}
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', marginBottom: '16px' }}>
                                        {selectedRecommendation?.link && (
                                            <Button
                                                variant="outlined"
                                                href={selectedRecommendation.link}
                                                target="_blank"
                                                style={{
                                                    borderColor: 'rgba(255, 255, 255, 0.15)',
                                                    color: '#ffffff',
                                                    textTransform: 'none',
                                                    fontSize: '13px',
                                                    fontWeight: 500
                                                }}
                                            >
                                                🔗 View Job Listing
                                            </Button>
                                        )}

                                        {(defaultPdf || editUsuarioData?.pdf) && (
                                            <Button
                                                variant="outlined"
                                                onClick={() => setOpenPdf(true)}
                                                style={{
                                                    borderColor: '#8A2BE2',
                                                    color: '#8A2BE2',
                                                    textTransform: 'none',
                                                    fontSize: '13px',
                                                    fontWeight: 600
                                                }}
                                            >
                                                📄 Open CV PDF
                                            </Button>
                                        )}
                                    </div>

                                    {/* Target Job description */}
                                    {favoriteFeedback?.job && (
                                        <div style={{
                                            marginBottom: '16px',
                                            padding: '10px 14px',
                                            borderRadius: '8px',
                                            backgroundColor: 'rgba(255, 255, 255, 0.03)',
                                            borderLeft: '3px solid #FF00FF',
                                            fontSize: '13px',
                                            color: '#e4e4e7',
                                            wordBreak: 'break-word',
                                            overflowWrap: 'anywhere'
                                        }}>
                                            <strong style={{ color: '#FF00FF' }}>Target Job Description:</strong>{' '}
                                            {favoriteFeedback.job}
                                        </div>
                                    )}

                                    {/* AI Match text parsed */}
                                    <div style={{
                                        flex: 1,
                                        overflowY: 'auto',
                                        maxHeight: '620px',
                                        paddingRight: '8px',
                                        fontSize: '14px',
                                        color: '#e4e4e7',
                                        lineHeight: '1.6',
                                        wordBreak: 'break-word',
                                        overflowWrap: 'anywhere'
                                    }} className="custom-scrollbar">
                                        {finalResult ? (
                                            <div dangerouslySetInnerHTML={{ __html: finalResult }} />
                                        ) : (
                                            <div style={{ color: '#a0a0ab', textAlign: 'center', padding: '40px 0' }}>
                                                No starred AI Resume Feedback available for this profile.
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal className={'modalContent'} open={openPdf} onClose={() => setOpenPdf(false)} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                <div style={{ margin: '20px auto', backgroundColor: 'white', width: '90%', height: '90vh', position: 'relative', borderRadius: '12px', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                    <div style={{ padding: '12px 24px', borderBottom: '1px solid #ccc', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#f3f4f6' }}>
                        <span style={{ fontWeight: 600, color: '#374151', fontSize: '16px', fontFamily: '"Outfit", sans-serif' }}>Curriculum PDF Viewer</span>
                        <Button variant="outlined" color="secondary" onClick={() => setOpenPdf(false)}>Close</Button>
                    </div>
                    <div style={{ flex: 1, overflow: 'auto', backgroundColor: '#525659' }}>
                        {(defaultPdf || editUsuarioData?.pdf) ? (
                            <Worker workerUrl={workerUrl}>
                                <Viewer
                                    fileUrl={serverConfig.dev.url + 'images/pdf/' + (defaultPdf || editUsuarioData.pdf)}
                                    plugins={[defaultLayoutPluginInstance]}
                                />
                            </Worker>
                        ) : (
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: 'white', fontSize: '18px' }}>
                                No PDF file is loaded for this user.
                            </div>
                        )}
                    </div>
                </div>
            </Modal>

            <Dialog open={deleteConfirmationOpen} onClose={() => setDeleteConfirmationOpen(false)}>
                <DialogTitle>Confirm </DialogTitle>
                <DialogContent>
                    <Typography variant="body1">Are you sure you want to delete?</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDeleteConfirmationOpen(false)}>Cancel</Button>
                    <Button onClick={handleDeleteConfirmation} color="secondary">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={addUsuarioModalOpen} onClose={() => setAddUsuarioModalOpen(false)}>
                <DialogTitle>Adicionar Usuario</DialogTitle>
                <DialogContent className={'modalContent'}>
                    <TextField
                        label="Name"
                        value={newUsuarioName}
                        onChange={(e) => setNewUsuarioName(e.target.value)}
                    />
                    <TextField
                        label="E-mail"
                        value={newUsuarioEmail}
                        onChange={(e) => setNewUsuarioEmail(e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Email />
                                </InputAdornment>
                            ),
                        }}
                        error={!validateEmail(newUsuarioEmail)}
                        helperText={!validateEmail(newUsuarioEmail) && 'E-mail inválido'}
                    />
                    <TextField
                        label="Password"
                        value={newUsuarioPassword}
                        onChange={(e) => {
                            setNewUsuarioPassword(e.target.value)
                        }}
                        type="password"
                        error={!validatePassword(newUsuarioPassword)}
                        helperText={!validatePassword(newUsuarioPassword) && 'A senha deve ter pelo menos 6 caracteres'}
                    />
                    <TextField
                        label="Confirm password"
                        value={newUsuarioConfirmPassword}
                        onChange={(e) => {
                            setNewUsuarioConfirmPassword(e.target.value)
                        }}
                        type="password"
                        error={!validateConfirmPassword(newUsuarioPassword, newUsuarioConfirmPassword)}
                        helperText={!validateConfirmPassword(newUsuarioPassword, newUsuarioConfirmPassword) && 'As senhas não correspondem'}
                    />
                    <FormControl fullWidth>
                        <InputLabel htmlFor="empresa-select">Selecione a Empresa</InputLabel>
                        <Select
                            value={newUsuarioEmpresa}
                            onChange={(e: any) => setNewUsuarioEmpresa(e.target.value)}
                            inputProps={{
                                name: 'empresa',
                                id: 'empresa-select',
                            }}
                        >
                            {empresas.map((empresa: { _id: any; nome: any; }) => (
                                <MenuItem key={empresa._id} value={empresa._id}>
                                    {empresa.nome}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="permissao-select">Selecione o tipo de usuário</InputLabel>
                        <Select
                            value={newUsuarioPermissoes}
                            onChange={(e: any) => setNewUsuarioPermissoes(e.target.value)}
                            inputProps={{
                                name: 'permissao',
                                id: 'permissao-select',
                            }}
                        >
                            {permissoesList.map((permissao: any) => (
                                <MenuItem key={permissao} value={permissao}>
                                    {permissao}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>


                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setAddUsuarioModalOpen(false)}>Cancelar</Button>
                    <Button onClick={handleAddUsuario} color="primary">
                        Criar
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog maxWidth="lg" open={selectedCompany && selectedCompany?.name} onClose={() => setSelectedCompany({})}>
                <DialogTitle>  Paste a link to the job listing (with job description) by: {selectedCompany?.name}</DialogTitle>
                <DialogContent className={'modalContent'}>

                    <TextField
                        label="Paste the link here"
                        value={editUsuarioData.email}
                        onChange={(e) => setLink(e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Link />
                                </InputAdornment>
                            ),
                        }}
                        error={!validateEmail(editUsuarioData.email)}
                        helperText={!validateEmail(editUsuarioData.email) && 'E-mail inválido'}
                    />



                    {/* <FormControl fullWidth>
              <InputLabel htmlFor="permissao-select">Selecione o tipo de usuário</InputLabel>
              <Select
                value={newUsuarioPermissoes}
                onChange={(e: any) => setNewUsuarioPermissoes(e.target.value)}
                inputProps={{
                  name: 'permissao',
                  id: 'permissao-select',
                }}
              >
                {permissoesList.map((permissao: any) => (
                  <MenuItem key={permissao} value={permissao}>
                    {permissao}
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}


                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setSelectedCompany({})}>Cancelar</Button>
                    <Button onClick={handleSendLink} color="primary">
                        Send
                    </Button>
                </DialogActions>
            </Dialog>


            {/* <Modal open={editUsuarioModalOpen} onClose={() => setEditUsuarioModalOpen(false)}>
  <div>
    <input
      type="text"
      value={editUsuarioData.nome}
      onChange={(e) => setEditUsuarioData({ ...editUsuarioData, nome: e.target.value })}
    />
    <input
      type="text"
      value={editUsuarioData.email}
      onChange={(e) => setEditUsuarioData({ ...editUsuarioData, email: e.target.value })}
    />
    <input
      type="text"
      value={editUsuarioData.telefone}
      onChange={(e) => setEditUsuarioData({ ...editUsuarioData, telefone: e.target.value })}
    />
    <input
      type="text"
      value={editUsuarioData.cnpj}
      onChange={(e) => setEditUsuarioData({ ...editUsuarioData, cnpj: e.target.value })}
    />
    <button onClick={handleUpdateUsuario}>Atualizar</button>
  </div>
</Modal> */}
        </Container>
    );
};

const mapStateToProps = (state: any) => ({

    user: state.user.user,
    isLoadingUsuarios: state.usuarios.isLoadingUsuarios,
    isLoadingUsuariosByFilter: state.usuarios.isLoadingUsuariosByFilter,
    isLoadingCreateUsuario: state.usuarios.isLoadingCreateUsuario,
    empresas: state.empresas.empresas
});

const mapDispatchToProps = {

};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(ScoutPage);
